<ng-container [formGroup]="form">
    <fieldset 
        class="_mb-4"
        [ngClass]="modifierClassname">
        <label 
            class="_inline-block _relative _ml-2 _mb-1 _text-md"
            [class._required-field]="required"
            [ngClass]="darkTheme ? '_text-white' : '_text-black'">
            {{label}}
        </label>
        <ngx-intl-tel-input 
            class="_input-squared _input-slim _px-2"
            [ngClass]="{ '_input-dark' : darkTheme, '_min-w-60' : useMinWidth }"
            [class._input-invalid]="control.invalid && control.touched"
            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
            [searchCountryFlag]="true"
            [separateDialCode]="true"
            [selectedCountryISO]="countryIso"
            [formControlName]="fieldId">
        </ngx-intl-tel-input>
        <div *ngIf="control.invalid && control.touched" class="_text-error-red-light _text-sm _mt-1 _ml-2">
            <div>Please provide a valid phone number</div>
        </div>
    </fieldset> 
</ng-container>
